import {
    Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, DialogContent,
    Typography, TableRow, styled, tableCellClasses, Dialog, DialogTitle, Divider
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import Snackbar from '.././Snacbar'
import Home from '../home/Home'
import { Col, Row, Form } from 'react-bootstrap';
import BillingService from '../../Services/billing/BillingService';
import { getUserId } from '../Utils/Common';
import BillingReportsService from '../../Services/Reports/BillingReportsService';



const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: 'Times New Roman',

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
    },
}));


const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item2 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: '#EADFB2',
    height: '100%',
    border: '1px solid black'
}));

function TransportBill() {
    const mystyle1 = {
        fontWeight: "bolder",
        color: "#0b64c5", fontFamily: 'Times New Roman',
      };
    const [open, setopen] = useState(false);
    const [message, setmessage] = useState('');
    const [severit, setseverit] = useState('');

    const [trnsData, setTransData] = useState([]);
    const [StateDrp, setStateDrp] = useState([]);
    const [addchargeOpen, setaddchargeOpen] = useState(false)
    const [BillPrintAlertopen, setBillPrintAlertopen] = useState(false);
    const [processVal, setprocessVal] = useState({
        save: false,
        update: false,
        delete: false
    })
    const [DisaVal, setDisaVal] = useState({
        save: false,
        update: true,
        delete: true
    })
    const [DiaprocessVal, setDiaprocessVal] = useState({
        save: false,
        update: false,
        delete: false
    })
    const [DiaDisaVal, setDiaDisaVal] = useState({
        save: false,
        update: true,
        delete: true
    })

    const [values, setValues] = useState({
        transpor_id: '',
        job_no: '',
        transporter_br_name: "",
        transporter_br_state_name: "",
        // transpor_id: '',
        bill_no: '',
        Receiver_name: "",
        Receiver_address: "",
        transporter_gstin: "",
        transporter_state_name: "",
        invoice_date: "",
        vessel: "",
        shipp_inv_no: "",
        booking_no: "",
        // other_ref: "",
        container_no: "",
        port_of_orgi: "",
        port_of_discharge: "",
        equipment_size: "",
        // dispatched_through: "",
        // destination: "",
        // be_no: "",
        // be_date: "",
        no_of_pkgs: "",
        // packages: "",
        // vehicle_no: "",
        // transporter_account: "",
        shipment_mode: '',
        transit_mode: ''
    })
    const [billName, setbillName] = useState([])
    const [VoucherType, setVoucherType] = useState([])
    const [CurrencyDetails, setCurrencyDetails] = useState([])
    const [ChanrgesData, setchargesData] = useState([])
    const [dialogValues, setDailogeValues] = useState({
        charges_id: '',
        charges_name: '',
        voucher_type: '',
        bill_voucher_type: '',
        //
        currency: '',
        unit: '',
        rate: '',
        //
        amount: '',
        gst: '',
    })

    const handleClose = () => {
        setopen(false);
    }

    //

    const trns_velidation = () => {
        if (!values.Receiver_name || values.Receiver_name === '') {
            setopen(true);
            setmessage('Receiver Name is empty');
            setseverit('warning');
        } else {
            if (!values.Receiver_address || values.Receiver_address === '') {
                setopen(true);
                setmessage('Receiver Address is empty');
                setseverit('warning');
            } else {
                if (!values.transporter_gstin || values.transporter_gstin === '') {
                    setopen(true);
                    setmessage('Receiver GSTIN is empty');
                    setseverit('warning');
                } else {
                    if (!values.transporter_state_name || values.transporter_state_name === '') {
                        setopen(true);
                        setmessage('Receiver State Name is empty');
                        setseverit('warning');
                    } else {
                        if (!values.invoice_date || values.invoice_date === '') {
                            setopen(true);
                            setmessage('Invoice Date is empty');
                            setseverit('warning');
                        } else {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }

    const save_transCharge = () => {
        if (trns_velidation() === true) {
            setprocessVal({ ...processVal, save: true });
            setDisaVal({ ...DisaVal, save: true });
            let details = {
                place_of_supply: values.transporter_br_name, state_code: values.transporter_br_state_name, invoice_date: values.invoice_date,
                receiver_name: values.Receiver_name, receiver_address: values.Receiver_address, receiver_state: values.transporter_state_name, receiver_gstin_no: values.transporter_gstin,
                vessel: values.vessel, shipper_inv_no: values.shipp_inv_no, booking_no: values.booking_no, no_of_pkg: values.no_of_pkgs, container_no: values.container_no, port_of_origin: values.port_of_orgi,
                port_of_discharge: values.port_of_discharge, equipment_size: values.equipment_size, shipment_type: values.shipment_mode, shipment_mode: values.transit_mode, updated_by: getUserId()
            }
            BillingService.addTransportDetails(details).then((res) => {
                const data = res.data;

                setmessage(data.message[0]);
                setseverit('success');
                setopen(true)
                Reset(); getTransData();
            }).catch((error) => {
                console.log('error', error); Reset()
                // setmessage(error);
                // setseverit('error');
                // setopen(true)
            });
        }

    }
    const update_transCharge = () => {
        if (trns_velidation() === true) {
            if (values.transpor_id === '' || !values.transpor_id) {
                setmessage('Transport details Grid is empty / not selected');
                setseverit('warning');
                setopen(true)
            } else {
                setprocessVal({ ...processVal, update: true });
                setDisaVal({ ...DisaVal, update: true });
                let details = {
                    transpor_id: values.transpor_id, place_of_supply: values.transporter_br_name, state_code: values.transporter_br_state_name, invoice_date: values.invoice_date,
                    receiver_name: values.Receiver_name, receiver_address: values.Receiver_address, receiver_state: values.transporter_state_name, receiver_gstin_no: values.transporter_gstin,
                    vessel: values.vessel, shipper_inv_no: values.shipp_inv_no, booking_no: values.booking_no, no_of_pkg: values.no_of_pkgs, container_no: values.container_no, port_of_origin: values.port_of_orgi,
                    port_of_discharge: values.port_of_discharge, equipment_size: values.equipment_size, shipment_type: values.shipment_mode, shipment_mode: values.transit_mode, updated_by: getUserId()
                }
                BillingService.updateTransportDetails(details).then((res) => {
                    const data = res.data;

                    setmessage(data.message[0]);
                    setseverit('success');
                    setopen(true)
                    Reset(); getTransData();
                }).catch((error) => {
                    console.log('error', error); Reset()
                    // setmessage(error);
                    // setseverit('error');
                    // setopen(true)
                });
            }
        }

    }
    const delete_transCharge = () => {
        if (trns_velidation() === true) {
            if (values.transpor_id === '' || !values.transpor_id) {
                setmessage('Transport details Grid is empty / not selected');
                setseverit('warning');
                setopen(true)
            } else {
                setprocessVal({ ...processVal, delete: true });
                setDisaVal({ ...DisaVal, delete: true });

                BillingService.deleteTransportDetails(values.transpor_id).then((res) => {
                    const data = res.data;

                    setmessage(data.message[0]);
                    setseverit('success');
                    setopen(true)
                    Reset(); getTransData();
                }).catch((error) => {
                    console.log('error', error); Reset()
                    // setmessage(error);
                    // setseverit('error');
                    // setopen(true)
                });
            }
        }

    }

    const Reset = () => {

        setValues({
            ...values, transpor_id: '', job_no: '', transporter_br_name: "", transporter_br_state_name: "",
            bill_no: '', Receiver_name: "", Receiver_address: "", transporter_gstin: "", transporter_state_name: "",
            invoice_date: "", vessel: "", shipp_inv_no: "", booking_no: "", container_no: "", port_of_orgi: "",
            port_of_discharge: "", equipment_size: "", no_of_pkgs: "", shipment_mode: '',
            transit_mode: ''
        });
        setprocessVal({ ...processVal, save: false, update: false, delete: false });
        setDisaVal({ ...DisaVal, save: false, update: true, delete: true });
    }

    //
    const charges_velidation = () => {
        if (!dialogValues.charges_name || dialogValues.charges_name === '') {
            setopen(true);
            setmessage('Bill Name is empty');
            setseverit('warning');
        } else {
            if (!dialogValues.voucher_type || dialogValues.voucher_type === '') {
                setopen(true);
                setmessage('voucher type is empty');
                setseverit('warning');
            } else {
                if (!dialogValues.amount || dialogValues.amount === '') {
                    setopen(true);
                    setmessage('Amount is empty');
                    setseverit('warning');
                } else {
                    if (!dialogValues.gst || dialogValues.gst === '') {
                        setopen(true);
                        setmessage('GST is empty');
                        setseverit('warning');
                    } else {

                        return true;

                    }
                }
            }
        }
        return false;
    }


    const save_Charge = () => {
        if (charges_velidation() === true) {
            setDiaprocessVal({ ...DiaprocessVal, save: true });
            setDiaDisaVal({ ...DiaDisaVal, save: true });
            let details = {
                created_by: getUserId(), transpoter_id: values.transpor_id, charge_name: dialogValues.charges_name, charge_type: dialogValues.voucher_type,
                currency: dialogValues.currency, unit: dialogValues.unit, rate: dialogValues.rate, total_amount: dialogValues.amount, gst: dialogValues.gst
            }
            BillingService.addTransport_charges(details).then((res) => {
                const data = res.data;

                setmessage(data.message[0]);
                setseverit('success');
                setopen(true)
                bill_data();
                Reset_Charge();
            }).catch((error) => {
                console.log('error', error); bill_data();
                Reset_Charge();
                // setmessage(error);
                // setseverit('error');
                // setopen(true)
            });
        }

    }
    const update_Charge = () => {
        if (charges_velidation() === true) {
            if (dialogValues.charges_id === '' || !dialogValues.charges_id) {
                setmessage("charge's details Grid is empty / not selected");
                setseverit('warning');
                setopen(true)
            } else {
                setDiaprocessVal({ ...DiaprocessVal, update: true });
                setDiaDisaVal({ ...DiaDisaVal, update: true });
                let details = {
                    created_by: getUserId(), transpoter_id: values.transpor_id, charge_name: dialogValues.charges_name, charge_type: dialogValues.voucher_type,
                    currency: dialogValues.currency, unit: dialogValues.unit, rate: dialogValues.rate, total_amount: dialogValues.amount, gst: dialogValues.gst
                }
                BillingService.updateTransport_charges(dialogValues.charges_id, details).then((res) => {
                    const data = res.data;

                    setmessage(data.message[0]);
                    setseverit('success');
                    setopen(true)
                    bill_data();
                    Reset_Charge();
                }).catch((error) => {
                    console.log('error', error); bill_data();
                    Reset_Charge();
                    // setmessage(error);
                    // setseverit('error');
                    // setopen(true)
                });
            }
        }

    }
    const delete_Charge = () => {
        if (charges_velidation() === true) {
            if (dialogValues.charges_id === '' || !dialogValues.charges_id) {
                setmessage("Charge's details Grid is empty / not selected");
                setseverit('warning');
                setopen(true)
            } else {
                setDiaprocessVal({ ...DiaprocessVal, delete: true });
                setDiaDisaVal({ ...DiaDisaVal, delete: true });

                BillingService.deleteTransport_charges(dialogValues.charges_id).then((res) => {
                    const data = res.data;

                    setmessage(data.message[0]);
                    setseverit('success');
                    setopen(true)
                    bill_data();
                    Reset_Charge();
                }).catch((error) => {
                    console.log('error', error.message); bill_data();
                    Reset_Charge();
                    // setmessage(error);
                    // setseverit('error');
                    // setopen(true)
                });
            }
        }

    }

    const Reset_Charge = () => {

        setDailogeValues({
            ...dialogValues, charges_id: '', currency: '', unit: '', rate: '',
            charges_name: '', voucher_type: '', amount: '', gst: ''
        });
        setDiaprocessVal({ ...DiaprocessVal, save: false, update: false, delete: false });
        setDiaDisaVal({ ...DiaDisaVal, save: false, update: true, delete: true });
    }

    //

    const BillPrintAlerthandeler=(action)=>{
        generateInvoice_Transporter_export(action);
      }

    const generateInvoice_Transporter_export = (action) => {
        if (values.transpor_id === '' || !values.transpor_id) {
            setmessage("Transport details Grid is empty / not selected");
            setseverit('warning');
            setopen(true)
        } else {
            var billby='';
            
            if (values.shipment_mode === 'IMPORTER' || values.shipment_mode === 'EXPORTER') {
              billby = '1'
            } else {
              billby = '2'
            }
            let details = {
               billNo: '-1', flagbill: 1, createdBy: getUserId(), voucherType: dialogValues.bill_voucher_type,billType:null,
              iecNo: '-1', fwdcode: '-1', billPaidBy: "SCOPE", billBy: billby, fileName: values.transpor_id+'-TranportBill',logoFlag:action, shipmentMode: values.transit_mode,
              transport_id:values.transpor_id,job_no:values.job_no.toString()
                  }
            // let details = { bill_no: values.bill_no, jobNo: values.job_no }
            BillingService.TransistBillprintPDF_DAO(details).then((res) => {

                const data = res.data;

                window.open('http://35.154.221.117:8081/ExportFiles/' + data.message[0])

            }).catch((error) => {
                console.log('error ', error.message)
            })
        }
    }

    //

    const transShiphmentModeChange = (e) => {
        setValues({ ...values, shipment_mode: e.target.value })
    }
    const tranTransModeChangehandler = (e) => {
        setValues({ ...values, transit_mode: e.target.value })
    }
    const transporterNameChangehandler = (e) => {
        setValues({ ...values, Receiver_name: e.target.value })
    }
    const transporterAddressChangehandler = (e) => {
        setValues({ ...values, Receiver_address: e.target.value })
    }
    const transporterGSTINChangehandler = (e) => {
        setValues({ ...values, transporter_gstin: e.target.value })
    }
    const transporterBrStateNameChangehandler = (e) => {
        setValues({ ...values, transporter_br_state_name: e.target.value })
    }
    const transporterStateNameChangehandler = (e) => {
        setValues({ ...values, transporter_state_name: e.target.value })
    }
    const transporterBranchNameChangehandler = (e) => {
        setValues({ ...values, transporter_br_name: e.target.value })
    }
    const transporterInvoiceDateChangehandler = (e) => {
        setValues({ ...values, invoice_date: e.target.value })
    }
    const delivery_noteChangehandler = (e) => {
        setValues({ ...values, vessel: e.target.value })
    }
    const mode_or_terms_of_paymentChangehandler = (e) => {
        setValues({ ...values, shipp_inv_no: e.target.value })
    }
    const supplier_refChangehandler = (e) => {
        setValues({ ...values, booking_no: e.target.value })
    }

    const buyer_order_noChangehandler = (e) => {
        setValues({ ...values, container_no: e.target.value })
    }
    const buyer_order_dateChangehandler = (e) => {
        setValues({ ...values, port_of_orgi: e.target.value })
    }
    const dispatch_doc_noChangehandler = (e) => {
        setValues({ ...values, port_of_discharge: e.target.value })
    }
    const delivery_note_dateChangehandler = (e) => {
        setValues({ ...values, equipment_size: e.target.value })
    }

    const no_of_pkgsChangehandler = (e) => {
        setValues({ ...values, no_of_pkgs: e.target.value })
    }


    //

    const Bill_VoucherTypeChangehandler = (e) => {
        setDailogeValues({ ...dialogValues, bill_voucher_type: e.target.value });
    }
    const chargesNameChangehandler = (e) => {
        setDailogeValues({ ...dialogValues, charges_name: e.target.value });
    }

    const VoucherTypeChangehandler = (e) => {
        setDailogeValues({ ...dialogValues, voucher_type: e.target.value });
    }
    const CurrencyChangehandler = (e) => {
        setDailogeValues({ ...dialogValues, currency: e.target.value });
    }
    const UnitChangehandler = (e) => {
        setDailogeValues({ ...dialogValues, unit: e.target.value });
    }
    const RateChangehandler = (e) => {
        setDailogeValues({ ...dialogValues, rate: e.target.value });
    }
    const AmountChangehandler = (e) => {
        setDailogeValues({ ...dialogValues, amount: e.target.value });
    }
    const gstinPercentChangehandler = (e) => {
        setDailogeValues({ ...dialogValues, gst: e.target.value });
    }

    const getTransData = () => {
        BillingService.getTransportDetails().then((res) => {
            setTransData(res.data);
        })
        BillingService.getDeliveryStateNameAll().then((res) => {
            setStateDrp(res.data);
        })
    }

    const bill_data = () => {
        BillingService.getbillName('-1').then((res) => { setbillName(res.data); });
        BillingService.getVoucherType().then((res) => { setVoucherType(res.data); });
        BillingReportsService.getCurrencyName().then((res) => { setCurrencyDetails(res.data); });
        BillingService.getTransport_charges(values.transpor_id).then((res) => { setchargesData(res.data); });
    }

    useEffect(() => {
        getTransData();
    }, []);


    const edit_transitDetails = (item) => {
        setValues({
            ...values, transpor_id: item.transpor_id, job_no: item.job_no, transporter_br_name: item.place_of_supply, transporter_br_state_name: item.state_code,
            Receiver_name: item.receiver_name, Receiver_address: item.receiver_address, transporter_gstin: item.receiver_gstin_no, transporter_state_name: item.delivery_state_name,
            invoice_date: item.invoice_date, vessel: item.vessel, shipp_inv_no: item.shipper_inv_no, booking_no: item.booking_no, container_no: item.container_no, port_of_orgi: item.port_of_origin,
            port_of_discharge: item.port_of_discharge, equipment_size: item.equipment_size, no_of_pkgs: item.no_of_pkg, shipment_mode: item.shipment_type,
            transit_mode: item.shipment_mode
        });
        setDisaVal({ ...DisaVal, save: true, update: false, delete: false });
    }
    const edit_ChargesDetails = (item) => {
        setDailogeValues({
            ...dialogValues, charges_id: item.charges_id, charges_name: item.charge_name, voucher_type: item.charge_type, amount: item.total_amount, gst: item.igst, currency: item.currency,
            unit: item.unit, rate: item.rate
        })
        setDiaDisaVal({ ...DiaDisaVal, save: true, update: false, delete: false });
    }

    const OpenChargesDialoge = () => {
        if (values.transpor_id === '' || !values.transpor_id) {
            setmessage('transport_id details Grid is empty / not selected');
            setseverit('warning');
            setopen(true)
        } else {
            setaddchargeOpen(true);
            bill_data();
            Reset_Charge();
        }
    }
    const closeChargesDialoge = () => {
        setaddchargeOpen(false)
    }
    const printAlertClickClose=()=>{
        setBillPrintAlertopen(false)
      }

      const printAlertClickOpen=()=>{
        setBillPrintAlertopen(true)
         
      }
    return (
        <div className='transporter_all'>
            <Home />
            <Dialog open={addchargeOpen} onClose={closeChargesDialoge} fullWidth={true}
                maxWidth={'md'}>
                <Dialog open={BillPrintAlertopen} onClose={printAlertClickClose}>
                    <DialogContent style={mystyle1}>
                        {"Print Preferences"}
                        {/* </DialogTitle>   generateInvoice_Transporter_export
          <DialogContent> */}
                        <center>
                        <Form.Label className='labl_red'>Voucher Type:</Form.Label>
                                {/* </Col>
                                    <Col> */}
                                <Form.Select value={dialogValues.bill_voucher_type} style={{ textAlign: 'center' }} size='sm'
                                    onChange={Bill_VoucherTypeChangehandler}>
                                    <option value=''> </option>
                                    {VoucherType.map((item) => (
                                        <option value={item.voucherType}>{item.voucherType}</option>
                                    ))}
                                </Form.Select>
                                <br></br>
                            <Button size="sm" variant="outline-primary" onClick={() => BillPrintAlerthandeler(1)}>WithLogo</Button>{'  '}
                            <Button size="sm" variant="outline-primary" onClick={() => BillPrintAlerthandeler(2)}>WithOut Logo</Button>
                        </center>
                    </DialogContent>
                </Dialog>
                <DialogTitle>
                    <center style={{ fontFamily: 'Times New Roman' }}><h6>Add Transportation Charges</h6></center>
                    <Divider color="#FDA228" sx={{ height: 2 }} />
                </DialogTitle>
                <DialogContent>
                    <Row>
                        <Col ><Form.Label className='labl_red'>JobNo:</Form.Label>
                            <Form.Control disabled value={values.job_no} style={{ textAlign: 'center' }} size='sm' />
                        </Col>

                        <Col ><Form.Label className='labl_red'>Bill No:</Form.Label>
                            <Form.Control disabled value={values.bill_no} style={{ textAlign: 'center' }} size='sm' />
                        </Col>
                    </Row>
                    <br></br>
                    {/* <Row>
                        <Col> */}
                    <Item2>
                        <Row>
                            {/* <Col xs={3}></Col> */}
                            <Col style={{ textAlign: 'center' }}>
                                <Form.Label className='labl_red'>Charges Name:</Form.Label>
                                {/* </Col>
                                    <Col> */}
                                <Form.Select value={dialogValues.charges_name} size='sm'
                                    onChange={chargesNameChangehandler} style={{ textAlign: 'center' }}>
                                    <option value=''> </option>
                                    {billName.map((item) => (
                                        <option value={item.billName}>{item.billName}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col style={{ textAlign: 'center' }}>
                                <Form.Label className='labl_red'>Voucher Type:</Form.Label>
                                {/* </Col>
                                    <Col> */}
                                <Form.Select value={dialogValues.voucher_type} style={{ textAlign: 'center' }} size='sm'
                                    onChange={VoucherTypeChangehandler}>
                                    <option value=''> </option>
                                    {VoucherType.map((item) => (
                                        <option value={item.voucherType}>{item.voucherType}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col style={{ textAlign: 'center' }}>
                                <Form.Label className='labl_red'>Curruncy:</Form.Label>
                                {/* </Col>
                                    <Col> */}
                                <Form.Select value={dialogValues.currency} style={{ textAlign: 'center' }} size='sm'
                                    onChange={CurrencyChangehandler}>
                                    <option value=''> </option>
                                    {CurrencyDetails.map((item) => (
                                        <option value={item.currency_code}>{item.currency_code}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Row>
                        <br></br>
                        <Row>
                            <Col style={{ textAlign: 'center' }}>
                                <Form.Label className='labl_red'>Unit:</Form.Label>
                                {/* </Col>
                                    <Col> */}
                                <Form.Control value={dialogValues.unit} style={{ textAlign: 'center' }} size='sm'
                                    onChange={UnitChangehandler} />
                            </Col>
                            <Col style={{ textAlign: 'center' }}>
                                <Form.Label className='labl_red'>Rate:</Form.Label>
                                {/* </Col>
                                    <Col> */}
                                <Form.Control value={dialogValues.rate} style={{ textAlign: 'center' }} size='sm'
                                    onChange={RateChangehandler} />
                            </Col>
                            <Col style={{ textAlign: 'center' }}>
                                <Form.Label className='labl_red'>Amount:</Form.Label>
                                {/* </Col>
                                    <Col> */}
                                <Form.Control value={dialogValues.amount} style={{ textAlign: 'center' }} size='sm'
                                    onChange={AmountChangehandler} />
                            </Col>
                            <Col style={{ textAlign: 'center' }}>
                                <Form.Label className='labl_red'>GST%:</Form.Label>
                                {/* </Col>
                                    <Col> */}
                                <Form.Control value={dialogValues.gst} style={{ textAlign: 'center' }} size='sm'
                                    onChange={gstinPercentChangehandler} />
                            </Col>
                            {/* <Col xs={3}></Col> */}
                        </Row>
                    </Item2>
                    {/* </Col>
                    </Row> */}
                    <br></br>
                    <center>
                        <Button variant="contained" size='small' onClick={save_Charge} disabled={DiaDisaVal.save}>{DiaprocessVal.save ? 'Processing...' : 'SAVE'}</Button>{' '}
                        <Button variant="contained" size='small' onClick={update_Charge} disabled={DiaDisaVal.update}>{DiaprocessVal.update ? 'Processing...' : 'UPDATE'}</Button>{' '}
                        <Button variant="contained" size='small' onClick={delete_Charge} disabled={DiaDisaVal.delete}>{DiaprocessVal.delete ? 'Processing...' : 'DELETE'}</Button>{' '}
                        <Button variant="contained" size='small' onClick={Reset_Charge}>RESET</Button>{' '}
                        <Button variant="contained" size='small' onClick={printAlertClickOpen}>Print Bill</Button>
                    </center>
                    <br></br>
                    <Row>
                        <Col>
                            <Item>
                                <TableContainer sx={{ maxHeight: 250 }} className='scrollbarPrime'>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>SL.No</StyledTableCell>
                                                <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Charge's Name</StyledTableCell>
                                                <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Voucher Type</StyledTableCell>
                                                <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Curruncy</StyledTableCell>
                                                <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Unit</StyledTableCell>
                                                <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Rate</StyledTableCell>
                                                <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>GST%</StyledTableCell>
                                                <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Total Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {ChanrgesData.map((item, index) => (
                                                <TableRow hover key={index} onClick={() => edit_ChargesDetails(item)}>
                                                    <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>{index + 1}</StyledTableCell>
                                                    <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>{item.charge_name}</StyledTableCell>
                                                    <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>{item.charge_type}</StyledTableCell>
                                                    <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>{item.currency}</StyledTableCell>
                                                    <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>{item.unit}</StyledTableCell>
                                                    <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>{item.rate}</StyledTableCell>
                                                    <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>{item.igst}</StyledTableCell>
                                                    <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>{item.total_amount}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Item>
                        </Col>
                    </Row>
                </DialogContent>
            </Dialog>
            <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
            <div style={{ paddingLeft: '100px', transition: '1s', transitionDelay: 'revert-layer' }}>
                <center>
                    <Typography style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bold', fontSize: '20px', marginTop: '4%' }}>TRANSPORTATION</Typography>
                </center>
                <Row>
                    <Col>
                        <Item>
                            <Row>
                                <Col>
                                    <Form.Label className='labl_red'>Invoice Date:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control type='date' size='sm' value={values.invoice_date}
                                        onChange={transporterInvoiceDateChangehandler} />
                                </Col>
                                <Col> <Form.Label className='labl_red'>Branch Name:</Form.Label> </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.transporter_br_name}
                                        onChange={transporterBranchNameChangehandler} />
                                </Col>
                                <Col><Form.Label className='labl_red'>Branch State:</Form.Label> </Col>
                                <Col>
                                    <Form.Select value={values.transporter_br_state_name}
                                        onChange={transporterBrStateNameChangehandler}>
                                        <option value=''> </option>
                                        {StateDrp.map((item) => (
                                            <option value={item.customCode}>{item.deliveryStateName}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col>  <Form.Label className='labl_red'>Job No:</Form.Label></Col>
                                <Col> <Form.Control disabled size='sm' value={values.job_no} /></Col>
                            </Row>
                            <br></br>
                            <Row>
                                <Col>
                                    <Form.Label className='labl_red'>Receiver Name:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.Receiver_name}
                                        onChange={transporterNameChangehandler} />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_red'>Receiver Add:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control value={values.Receiver_address} size='sm' as='textarea'
                                        onChange={transporterAddressChangehandler} />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_red'>GSTIN.NO:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control value={values.transporter_gstin} size='sm'
                                        onChange={transporterGSTINChangehandler} />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_red'>Receiver State Name:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Select value={values.transporter_state_name}
                                        onChange={transporterStateNameChangehandler}>
                                        <option value=''> </option>
                                        {StateDrp.map((item) => (
                                            <option value={item.deliveryStateName}>{item.deliveryStateName} - {item.customCode}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                            </Row>
                            <br></br>
                            <Row>
                                <Col>
                                    <Form.Label className='labl_black'>Vessel:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.vessel}
                                        onChange={delivery_noteChangehandler} />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_black'>Shipper Inv.No:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.shipp_inv_no}
                                        onChange={mode_or_terms_of_paymentChangehandler} />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_black'>Booking.no:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.booking_no}
                                        onChange={supplier_refChangehandler} />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_black'>No.of.Pkgs:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.no_of_pkgs}
                                        onChange={no_of_pkgsChangehandler} />
                                </Col>
                            </Row>
                            <br></br>
                            <Row>
                                <Col>
                                    <Form.Label className='labl_black'>Container No:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.container_no}
                                        onChange={buyer_order_noChangehandler} />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_black'>Port of Origin:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.port_of_orgi}
                                        onChange={buyer_order_dateChangehandler}  />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_black'>Port of Discharge:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.port_of_discharge}
                                        onChange={dispatch_doc_noChangehandler} />
                                </Col>
                                <Col>
                                    <Form.Label className='labl_black'>Equipment size:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control size='sm' value={values.equipment_size}
                                        onChange={delivery_note_dateChangehandler} />
                                </Col>
                            </Row>
                            <br></br>
                            <Row>
                                <Col>
                                    <Form.Label className='labl_black'>Shipment Type:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Select value={values.shipment_mode}
                                        onChange={transShiphmentModeChange}>
                                        <option value=''> </option>
                                        <option value='IMPORT'>IMPORT</option>
                                        <option value='EXPORT'>EXPORT</option>
                                        {/* {StateDrp.map((item) => ( */}
                                        {/* <option value={item.customCode}>{item.deliveryStateName}</option> */}
                                        {/* ))} */}
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <Form.Label className='labl_black'>Transit Mode:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Select value={values.transit_mode}
                                        onChange={tranTransModeChangehandler}>
                                        <option value=''> </option>
                                        <option value='AIR'>AIR</option>
                                        <option value='SEA'>SEA</option>
                                        {/* {StateDrp.map((item) => (
                                            <option value={item.customCode}>{item.deliveryStateName}</option>
                                        ))} */}
                                    </Form.Select>
                                </Col>
                                <Col>

                                </Col>
                                <Col>
                                </Col>
                                <Col>

                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Item>
                    </Col>
                </Row>
                <br></br>
                <center>
                    <Button variant="contained" size='small' onClick={save_transCharge} disabled={DisaVal.save}>{processVal.save ? 'Processing...' : 'SAVE'}</Button>{' '}
                    <Button variant="contained" size='small' onClick={update_transCharge} disabled={DisaVal.update}>{processVal.update ? 'Processing...' : 'UPDATE'}</Button>{' '}
                    <Button variant="contained" size='small' onClick={delete_transCharge} disabled={DisaVal.delete}>{processVal.delete ? 'Processing...' : 'DELETE'}</Button>{' '}
                    <Button variant="contained" size='small' onClick={Reset}>RESET</Button>{' '}
                    <Button variant="contained" size='small' onClick={OpenChargesDialoge}>ADD CHARGES</Button>
                </center>
                <br></br>
                <Row>
                    <Col>
                        <Item>
                            <TableContainer sx={{ maxHeight: 250 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>SL.No</StyledTableCell>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Job.No</StyledTableCell>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Invoice date</StyledTableCell>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Rec_Name</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Address</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>GSTIN</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {trnsData.map((item, index) => (
                                            <TableRow hover key={index} onClick={() => edit_transitDetails(item)}>
                                                <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>{index + 1}</StyledTableCell>
                                                <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>{item.job_no}</StyledTableCell>
                                                <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>{item.invoice_date}</StyledTableCell>
                                                <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>{item.receiver_name}</StyledTableCell>
                                                <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>{item.receiver_address}</StyledTableCell>
                                                <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>{item.receiver_gstin_no}</StyledTableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default TransportBill